// @ts-nocheck
// src/data/listings.js
// Centralized listings "store" using localStorage (demo only)

const LS_KEY = "cardex_listings_v1";

export const CHIPS = ["All", "Magic: The Gathering", "Pokémon", "Yu-Gi-Oh!", "One Piece"];

const SEED = [
  {
    id: "1",
    title: "Luffy Gear 5 Alt Art",
    game: "One Piece",
    condition: "NM",
    price: 189.99,
    image:
      "https://images.unsplash.com/photo-1612036782180-6f0b6cd846fe?auto=format&fit=crop&w=1200&q=80",
    seller: "VictorTCG",
    time: "2h ago",
    description: "Sleeved + top loader. Ships next day.",
  },
  {
    id: "2",
    title: "Charizard VMAX (Shiny)",
    game: "Pokémon",
    condition: "LP",
    price: 129.0,
    image:
      "https://images.unsplash.com/photo-1611605698323-b1e99cfd37ea?auto=format&fit=crop&w=1200&q=80",
    seller: "CardHunter",
    time: "6h ago",
    description: "Clean edges, light surface wear. DM for closeups.",
  },
  {
    id: "3",
    title: "PSA 10 Blue-Eyes White Dragon",
    game: "Yu-Gi-Oh!",
    condition: "Slab 10",
    price: 299.0,
    image:
      "https://images.unsplash.com/photo-1610878180933-123728f3b402?auto=format&fit=crop&w=1200&q=80",
    seller: "SlabKing",
    time: "1d ago",
    description: "Perfect slab. Insured shipping.",
  },
];

function safeParse(raw, fallback) {
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : fallback;
  } catch {
    return fallback;
  }
}

export function getListings() {
  const raw = localStorage.getItem(LS_KEY);
  if (!raw) {
    localStorage.setItem(LS_KEY, JSON.stringify(SEED));
    return [...SEED];
  }
  return safeParse(raw, [...SEED]);
}

export function getListingById(id) {
  return getListings().find((x) => String(x.id) === String(id)) || null;
}

export function addListing(listing) {
  const items = getListings();
  const next = [listing, ...items];
  localStorage.setItem(LS_KEY, JSON.stringify(next));
  return listing;
}

export function deleteListing(id) {
  const items = getListings().filter((x) => String(x.id) !== String(id));
  localStorage.setItem(LS_KEY, JSON.stringify(items));
  return items;
}

export function makeId() {
  return String(Date.now());
}
